export const PHONE_NUMBER_REGEX = /^\d+$/;

export const EMAIL_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

export const PASSWORD_REGEX =
  /^(?=[^\s]{8,24}$)(?:(?=.*[a-z])(?=.*[A-Z])|(?=.*[a-z])(?=.*\d)|(?=.*[a-z])(?=.*[!"#$%&'()*+,\-./:;<=>?@\[\\\]^_`{|}~])|(?=.*[A-Z])(?=.*\d)|(?=.*[A-Z])(?=.*[!"#$%&'()*+,\-./:;<=>?@\[\\\]^_`{|}~])|(?=.*\d)(?=.*[!"#$%&'()*+,\-./:;<=>?@\[\\\]^_`{|}~]))/;

export const PHONE_NUMBER_ERROR_MESSAGE =
  "電話番号に半角数字以外が含まれています";
export const EMAIL_ERROR_MESSAGE = "正しいメールアドレスを入力してください。";
export const PASSWORD_ERROR_MESSAGE =
  "半角英数記号8文字以上24文字以内で、英字・数字・記号のうち2種類以上を混在させてください。";
